/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationGroupModifierSchema } from "./comboCalculationGroupModifierSchema.ts";
import { comboCalculationModifierSchema } from "./comboCalculationModifierSchema.ts";

export const comboCalculationItemSchema = z.object({
	id: z.uuid(),
	amount: z.int().min(1),
	size: z.uuid().nullish(),
	modifiers: z.array(comboCalculationModifierSchema).nullish(),
	group_modifiers: z.array(comboCalculationGroupModifierSchema).nullish(),
});
